import { Grid } from '@mui/material';

import LoginForm from './LoginForm';
import './Login.scss';
import person from '../../../common/icons/petrolbunk.jpg';
const Login = () => {
  // const theme = useTheme();
  return (
    <>
      <Grid container justifyContent='center' className='login'>
        <Grid item xs={6} className='login-image'>
          <img src={person} className='person-image' alt='' />
        </Grid>
        <Grid
          item
          xs={6}
          justifyContent='center'
          display={'flex'}
          alignItems={'center'}
          className='login-form-main'
        >
          <LoginForm />
        </Grid>
      </Grid>
    </>
  );
};
export default Login;
